/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipment_Status_PlannedInputs */

const en_shipment_status_planned = /** @type {(inputs: Shipment_Status_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planned`)
};

/**
* | output |
* | --- |
* | "Planned" |
*
* @param {Shipment_Status_PlannedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const shipment_status_planned = /** @type {((inputs?: Shipment_Status_PlannedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipment_Status_PlannedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_shipment_status_planned(inputs)
});